export class UrlBuilder {
  private action: string;
  private baseRouteParams: string[] = [];
  private routeParams: string[] = [];
  private queryParams: string[] = [];

  public params = new UrlBuilderParams(this);

  constructor(private targetService: string, action: string) {
    this.action = `${action}`;
  }

  public build(): string {
    const action = this.action.length ? `/${this.action}` : ``;
    let url = `${this.targetService}${this.baseRouteParams.join('/')}${action}${this.routeParams.join('/')}${this.queryParams.join('&')}`;
    url =  url.startsWith('//') ? url.substring(1) : url;
    return url;
  }

  public addQueryParam(key: string, value: string | number | boolean | undefined) {
    if (value !== undefined) {
      this.queryParams.push(this.queryParams.length > 0 ? `${key}=${value}` : `?${key}=${value}`);
    }
    return this;
  }

  public addQueryParamUrl(key: string, value: string | number | boolean | undefined) {
    if (value !== undefined) {
      this.addQueryParam(key, encodeURIComponent(`${value}`));
    }
    return this;
  }

  public addBaseRouteParam(route: string, value?: string) {
    const path = (value) ? `${route}/${value}` : route;
    this.baseRouteParams.push(this.baseRouteParams.length > 0 ? path : `/${path}`);
    return this;
  }

  public addRouteParam(route: string, value?: string) {
    const path = (value) ? `${route}/${value}` : route;
    this.routeParams.push(this.routeParams.length > 0 ? path : `/${path}`);
    return this;
  }
}

class UrlBuilderParams {
  constructor(private _urlBuilder: UrlBuilder) { }

  add(paramKey: string, paramValue: string | number | boolean) {
    this._urlBuilder.addQueryParam(paramKey, paramValue);
    return this;
  }

  addCountry(country: string) {
    this.add('country', country);
    return this;
  }

  addBusinessUnit(businessUnit: string) {
    this.add('businessUnit', businessUnit);
    return this;
  }

  addChannel(channel: string) {
    this.add('channel', channel);
    return this;
  }

  addCustomerNumber(customerNumber: string) {
    this.add('customerNumber', customerNumber);
    return this;
  }

  build() {
    return this._urlBuilder.build();
  }
}

export class EndpointHelper {

  constructor(private baseService: string) { }

  public createUrl(action?: string): UrlBuilder {
    return new UrlBuilder(this.baseService, action || '');
  }
}
